'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/shadcn/lib/utils';

const links = [
    { to: '/spoznajte-realico/co-je-realico', label: 'Čo je Realico?', type: 'text' as const },
    {
        to: '/spoznajte-realico/realico-x',
        label: 'Realico X',
        type: 'image' as const,
        image: '/images/brand/realicox_logo_white_gold_y_dot.svg',
    },
    { to: '/spoznajte-realico/biznis-s-realico', label: 'Biznis s Realico', type: 'text' as const },
    { to: '/spoznajte-realico/kontakt', label: 'Kontakt', type: 'text' as const },
];

interface Props {
    variant?: 'light' | 'dark';
}

export function AboutUsHeader({ variant = 'light' }: Props) {
    const pathname = usePathname();
    const onYellow = variant === 'light';

    const navBg = onYellow ? 'bg-[#c19402]' : 'bg-[#2c2c2c]';
    const linkBase = onYellow
        ? 'text-white/90 hover:text-white [&.active]:bg-white [&.active]:text-[#191919]'
        : 'text-white/80 hover:text-white [&.active]:bg-[#464646] [&.active]:text-white';

    return (
        <header className="relative inset-x-0 top-0 z-1000">
            <div className="mx-auto flex items-center gap-[15px] lg:gap-[20px] xl:gap-[25px]">
                <Link href="/" className="shrink-0">
                    <img
                        src={
                            onYellow
                                ? '/images/brand/realico_logo_full_white.svg'
                                : '/images/brand/realico_logo_w_y_dot.svg'
                        }
                        alt="Realico"
                        className="w-[100px] md:w-[120px] xl:w-[150px]"
                    />
                </Link>
                <nav
                    className={`hidden md:flex flex-1 items-center justify-between rounded-full shadow-sm p-[5px] ${navBg}`}
                >
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            href={l.to}
                            className={cn(
                                linkBase,
                                `flex-1 px-[20px] py-[8px] text-[12px] font-bold rounded-full transition-colors whitespace-nowrap flex items-center justify-center min-h-[40px]`,
                                'lg:text-[13px]',
                                'xl:text-[14px]',
                                pathname === l.to && ' active',
                            )}
                        >
                            {l.type === 'image' ? (
                                <img src={l.image} alt={l.label} className="h-6 w-auto xl:h-7" />
                            ) : (
                                l.label
                            )}
                        </Link>
                    ))}
                </nav>
            </div>
        </header>
    );
}
